const skills = [
    {
        name: "Python",
        icon: "/icons/skills/python.jpg",
        link:  "https://github.com/HariniS1018?tab=repositories&q=&type=&language=python&sort="
    },
    {
        name: "c++",
        icon: "/icons/skills/C++.png",
        link: "https://github.com/HariniS1018/maze-solver-DFS/blob/main/source-code.cpp"
    },
    {
        name: "Data Structures & Algorithms",
        icon: "/icons/skills/code.jpg",
        link: "https://github.com/HariniS1018/maze-solver-DFS/blob/main/source-code.cpp"
    },
    {
        name: "SQL",
        icon: "/icons/skills/sql.jpg",
        link: "https://github.com/HariniS1018/Attendance-Management-System"
    },
    {
        name: "LangChain & RAG",
        icon: "/icons/skills/langchain.jpg",
        link: "https://github.com/HariniS1018/Robust-RAG"
    },
    {
        name: "Node.js & Express.js",
        icon: "/icons/skills/node-js.jpg",
        link: ""
    },
    {
        name: "Git & Github",
        icon: "/icons/skills/git.jpg",
        link: "https://github.com/HariniS1018"
    },
    {
        name: "SDLC",
        icon: "/icons/skills/sdlc.jpg",
        link: "https://github.com/HariniS1018/Attendance-Management-System"
    },
    {
        name: "Streamlit",
        icon: "/icons/skills/streamlit.png",
        link: "https://github.com/HariniS1018/Robust-RAG"
    },
    {
        name: "FastAPI",
        icon: "/icons/skills/fastapi.png",
        link: "https://github.com/HariniS1018/Robust-RAG"
    },
    {
        name: "EDA",
        icon: "/icons/skills/eda.png",
        link: "https://github.com/HariniS1018/College-Performance-Analysis-and-Graduation-Rate-Prediction"
    },
    // {
    //     name: "Deep Learning (CNNs & GANs)",
    //     icon: "/icons/skills/tensorflow.jpg",
    //     link: "https://github.com/HariniS1018/GAN-MNIST"
    // },
    // {
    //     name: "Tableau",
    //     icon: "/icons/skills/tableau.jpg",
    //     link: "https://public.tableau.com/profile/TableauProfile"
    // },
];

export default skills;